export const registrationConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getClientList_request: "getClientList_request",
        getClientList_success: "getClientList_success",
        getClientList_failure: "getClientList_failure",

        addClient_request: "addClient_request",
        addClient_success: "addClient_success",
        addClient_failure: "addClient_failure",

        updateClient_request: "updateClient_request",
        updateClient_success: "updateClient_success",
        updateClient_failure: "updateClient_failure",

        deleteClient_request: "deleteClient_request",
        deleteClient_success: "deleteClient_success",
        deleteClient_failure: "deleteClient_failure",
    }

    let obj_formatted = {};
    let domain = "distributorPortal.registration/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}